import { Component, OnInit } from '@angular/core';
import { BaseContainer, ModalContainerService, ModalService, UserService, BaseModalContainer } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { RadnoVreme } from './radno-vreme';

@Component({
  selector: 'yt-radno-vreme',
  templateUrl: './radno-vreme.component.html'
})

export class RadnoVremeComponent 
extends BaseModalContainer<RadnoVreme>
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<RadnoVreme>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
